import createAction from './';

export const SET_SELF_AUDIO_STATUS = createAction('SET_SELF_AUDIO_STATUS');

export const setSelfAudioStatus = status => ({
  type: SET_SELF_AUDIO_STATUS,
  meta: { status },
});
